import { apiClient } from '@/lib/api/apiClient';
import { endpoints } from '@/lib/api/apiEndpoints';

export interface GameSessionDto {
  id: string;
  name: string;
  status: string;
  roomCode: string;
  createdAt: string;
  startedAt?: string;
  endedAt?: string;
  playerCount: number;
}

export interface PagedResult<T> {
  items: T[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalCount: number;
}

export const gameService = {
  async getActiveGames(params?: {
    pageNumber?: number;
    pageSize?: number;
  }): Promise<PagedResult<GameSessionDto>> {
    const response = await apiClient.get(`${endpoints.admin.games()}/active`, { params });
    return response.data.data;
  },

  async getGameHistory(params?: {
    startDate?: string;
    endDate?: string;
    pageNumber?: number;
    pageSize?: number;
  }): Promise<PagedResult<GameSessionDto>> {
    const response = await apiClient.get(`${endpoints.admin.games()}/history`, { params });
    return response.data.data;
  },

  async getGameDetails(id: string): Promise<GameSessionDto> {
    const response = await apiClient.get(endpoints.admin.game(id));
    return response.data.data;
  },
};
